import EndoscopyNav from "../../pages/Dashboard/Endoscopy/EndoscopyNav";
import EndoscopyIndex from "../../pages/Dashboard/Endoscopy/EndoscopyIndex";
import EndoscopyTestsPage from "../../pages/Dashboard/Endoscopy/EndoscopyTestsPage";
import PatientEndoscopyRecordsPage from "../../pages/Dashboard/Endoscopy/PatientEndoscopyRecordsPage";
import EndoscopyRecordDetailsPage from "../../pages/Dashboard/Endoscopy/EndoscopyRecordDetailsPage";

const endoscopyRoutes = {
  path: "/endoscopy",
  element: <EndoscopyNav />,
  children: [
    { path: "/endoscopy", element: <EndoscopyIndex /> },
    { path: "/endoscopy/tests", element: <EndoscopyTestsPage /> },
    { path: "/endoscopy/patient-records", element: <PatientEndoscopyRecordsPage /> },
    { path: "/endoscopy/patient-records/:id", element: <EndoscopyRecordDetailsPage /> },
  ],
};

export default endoscopyRoutes;
